<template>
  <div class="index">
    <!--顶部搜索框-->
    <searchBar></searchBar>
    <div class="index_content">
      <!--banner-->
      <van-swipe :autoplay="3000" indicator-color="white">
        <van-swipe-item v-for="(banner_img,index) in banner" :key="index">
          <a :href="banner_img.link">
            <img :src="banner_img.thumb" alt />
          </a>
        </van-swipe-item>
      </van-swipe>
      <!--菜单-->
      <div class="nav">
        <ul>
          <li v-for="(nav,index) in navs" :key="index">
            <template v-if="nav.wai_url==''">
                <router-link :to="{path: '/'+nav.url}" >
                  <div class="nav_imaBox"><img :src="nav.thumb" alt /></div>
                  <p>{{nav.name}}</p>
                </router-link>
            </template>
            <template v-else>
                <a :href="nav.wai_url" >
                  <div class="nav_imaBox"><img :src="nav.thumb" alt /></div>
                  <p>{{nav.name}}</p>
                </a>
            </template>
          </li>
        </ul>
      </div>
      <!--通知栏-->
      <van-notice-bar    class="fs_12 notice" id="notice"  background="none" left-icon=" iconfont icon-gonggao col_45B9BC fs_14" >
        {{'"'+notice+'"'}}
      </van-notice-bar>
      <!--门店-->
      <div class="stores">
        <div class="stores_head flex">
          <div class="icontext_center flex_center">
            <van-icon class="stores_head_icon" name="shop-o"></van-icon>
            <span>共享门店</span>
          </div>
          <div class="icontext_center flex_center">
            <van-icon class="stores_head_icon" name="location-o"></van-icon>
            <span>{{city}}</span>
          </div>
        </div>

        <div class="stores_content">
          <ul>
            <li v-for="(store,index) in stores" :key="index" >
              <router-link :to="{ path: '/storeDetails', query: { id: store.id }}">
                <div class="store_img_box">
                  <img :src="store.logo" alt />
                </div>
                <p class="store_name">{{store.storename}}</p>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
      <!--技师列表-->
      <div class="technician">
        <div class="technician_label">
          <span class="zfgf"></span>
          <span class="technician_label_tile">共享技师</span>
          <span class="yfgf"></span>
          <router-link class="technician_more" to="/technicianList">全部</router-link>
        </div>
      </div>
      <van-swipe class="detail" :loop="false" :show-indicators="false" :width="160">
        <van-swipe-item class="detail_technician" v-for="(techItem,index) in techList" :key="index">
          <router-link class="detail_technician_list" :to="{ path: '/technicianDetails', query: { tech_id: techItem.id }}">
            <div class="detail_avatar" v-if="techItem.type=='0'">
              <img class="detail_avatar_tech" :src="techItem.thumb?techItem.thumb:techItem.avatar" alt />
            </div>
            <div class="detail_avatar" v-if="techItem.type=='2'">
              <img class="detail_avatar_tech seniorTech" :src="techItem.thumb?techItem.thumb:techItem.avatar" alt />
              <img class="detail_avatar_crown" src="static/img/crown_icon.png" alt />
            </div>
            <div class="detail_avatar" v-if="techItem.type=='1'">
              <img class="detail_avatar_tech seniorTech seniorTech2" :src="techItem.thumb?techItem.thumb:techItem.avatar" alt />
              <img class="detail_avatar_crown" src="static/img/crown_icon2.png" alt />
            </div>
            <div class="detail_label">
              <p class="detail_name">{{techItem.name}}</p>
              <p class="detail_position">{{techItem.levelname}}</p>
            </div>
            <div class="detail_star">
              <span v-for="(item,index) in 5" :key="index">
                <van-icon class="star" size="15px" name="star" v-if="techItem.score > index" :color="star_active" />
                <van-icon class="star" size="15px" name="star" v-else/>
              </span>
            </div>
            <div class="detail_skills">
              <span v-for="(item,index) in techItem.service" :key="index">{{item}}</span>
            </div>
            <div class="detail_book">立即预约</div>
          </router-link>
        </van-swipe-item>
      </van-swipe>
      <!--服务项目-->
      <div class="technician">
        <div class="technician_label">
          <span class="zfgf"></span>
          <span class="technician_label_tile">养生服务</span>
          <span class="yfgf"></span>
          <router-link class="technician_more" to="/itemList">全部</router-link>
        </div>
      </div>
      <div class="itemList">
        <ul>
          <li class="" v-for="(item,index) in itemList" :key="index">
            <router-link  :to="{ path: '/itemDetails', query: { service_id: item.id}}" class="bg_fff radius3">
              <img :src="item.thumb_frist" alt="" class="service_img">
              <div class="itemList_content">
                <p class="itemList_title one">{{item.title}}</p>
                <p class="itemList_price"><span>￥{{item.price}}<span style="font-size:.6rem;"> 起</span></span>{{item.itemtime}}分钟/次</p>
              </div>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
    <!--底部固定导航-->
    <tab-bar :index-active="'active'" :index-icon="'/static/img/icon_nav11.png'"></tab-bar>
    <!--活动弹窗-->
    <van-popup v-model="show" get-container="body" :style="{ width: '64%' }" :overlay-style="{opacity:'.8'}">
      <img class="popup__textImg" src="/static/img/popup_text.png" alt="">
      <div class="popup__content">
        <div class="fw_500">养生分享券</div>
        <div class="popup__price"><small>¥</small>10</div>
        <div class="fs_12">满100可用</div>
        <div class="fs_10">有效期：2019.09.28-2019.10.08</div>
      </div>
      <div class="popup__btnBox"><router-link to="/" class="popup__getBtn">立即领取</router-link></div>
      <div class="activityPopup__closeBox" @click="showPopup"><span class="iconfont icon-guanbi1"></span></div>
    </van-popup>
  </div>
</template>

<script>
import searchBar from "@/components/searchBar.vue";
import tabBar from "@/components/tabBar.vue";
import storage from '@/common/storage';

export default {
  name: "index",
  components: { searchBar,tabBar },
  data() {
    return {
      show: false,    //活动弹窗,优惠券
      star_active: "#F9CE06",  //星星点灯颜色
      banner: [],
      notices:[],
      notice:'知孝感恩,守信敬业,诚实做人,踏实做事", "诚实做人,踏实做事,知孝感恩,守信敬业","诚实做人,踏实做事,知孝感恩,守信敬业。',
      navs: [
        // { url:"",img: "./static/img/nav_gy.png", label: "关于我们" ,wai_url:''},
        // { url:"storeList",img: "./static/img/nav_yy.png", label: "预约门店",wai_url:'' },
        // { url:"technicianList",img: "./static/img/nav_js.png", label: "预约技师" ,wai_url:''},
        // { url:"",img: "./static/img/nav_sc.png", label: "健康商城",wai_url:'https://h5.liuantang.com.cn/app/index.php?i=1&c=entry&m=ewei_shopv2&do=mobile' },
        // { url:"share",img: "./static/img/nav_hh.png", label: "合伙分享" ,wai_url:''}
      ],
      stores: [
      ],
      techList: [
      ],
      itemList: [
      ],
      city:'深圳'

    };
  },
  created(){

      var member_id = this.$route.query.member_id;

      if(member_id){
        storage.s_setItem('member_id', member_id);
      }else{
        storage.s_clear();
      }


      this.axios({
          url: this.api.index.main
      }).then((res) => {
          if (res.error === 0) {
              // 处理banner数据，替换旧域名
              this.banner = res.banner_data.map(item => {
                if (item.link && item.link.includes('h5.liuantang.com.cn')) {
                  item.link = item.link.replace('h5.liuantang.com.cn', 'h5.liuantang.com.cn');
                }
                return item;
              });
              
              this.notices = res.notice_data;
              var notice_title = '';
              for(var i=0;i<res.notice_data.length;i++){
                  notice_title += res.notice_data[i].title
              }
              this.notice = notice_title;
              this.stores = res.store_data;
              this.techList = res.tech_data;
              this.itemList = res.service_data;
              
              // 处理导航数据，替换旧域名
              this.navs = res.home_icon.map(item => {
                if (item.wai_url && item.wai_url.includes('h5.liuantang.com.cn')) {
                  item.wai_url = item.wai_url.replace('h5.liuantang.com.cn', 'h5.liuantang.com.cn');
                }
                return item;
              });
              // this.navs[0]['wai_url'] = res.about_url;
              // this.navs[3]['wai_url'] = res.shopping_url;
          }

      });
       this.get_location();
  },
  
  methods: {
    // 活动弹窗
    showPopup() {
      this.show = false;
    },
    get_location(){
      this.wx.wxgetlocation(result=>{
      
         this.axios({
           url: this.api.index.get_location,
           data:{
             lat:result.latitude,
             lng:result.longitude
           }
           
         }).then((res) => {
            if (res.error === 0) {
               this.city = res.city?res.city:'深圳'

            }

         });
      },()=>{
        this.city ='深圳'
      });
    }
  }
};
</script>

<style scoped>
  @import '../../assets/css/item.css';   /*(服务)项目样式*/
  /*活动弹窗*/
  .van-popup{
    background: none;
  }
  .itemList ul{
    padding: .65rem .25rem .15rem;
    overflow: hidden;
    display: flex;
    flex-wrap: wrap;
  }
  .notice{
    color: red;
    font-size: .75rem!important;
  }
  .popup__textImg{
    z-index: 999;
    width: 68%;
    margin: 0 auto;
  }
  .popup__content{
    background: url("/static/img/popup_headBg.png") no-repeat center;
    background-size: 100% 100%;
    -webkit-background-size: 100% 100%;
    color: #fff;
    text-align: center;
    font-size: .7rem;
    padding: 4.4rem .5rem .35rem;
    margin-top: -5rem;
  }
  .popup__price{
    font-size: 1.9rem;
    text-shadow: 0 2px 3px rgba(0,0,0,.4);
    font-weight: 900;
    line-height: 1.8rem;
    margin-top: .2rem;
  }
  .popup__price>small{
    font-size: 1.1rem;
  }
  .popup__btnBox{
    background: url("/static/img/popup_btnBg.png") no-repeat center;
    background-size: 100% 100%;
    -webkit-background-size: 100% 100%;
    text-align: center;
    color: #fff;
    padding: 1rem .5rem;
  }
  .popup__getBtn{
    background-image: linear-gradient(#86CCD4, #5DAAB6);
    background-image: -webkit-linear-gradient(#86CCD4, #5DAAB6);
    box-shadow: 2px 4px 6px rgba(93, 169, 181, 0.6);
    padding: 0 1.75rem;
    line-height: 1.8rem;
    border-radius: 1.8rem;
    font-size: .75rem;
    font-weight: 500;
  }
  .activityPopup__closeBox{
    text-align: center;
    padding: .75rem 0;
  }
  .activityPopup__closeBox .iconfont{
    font-size: 1.5rem;
    display: inline-block;
    color: rgba(255,255,255,.8);
  }

  /*菜单导航*/
  .nav{
    padding:.65rem .5rem;
    background-color:white;
    clear:both;
    overflow:hidden;
  }
  .nav ul{
    display: flex;
  }
  .nav li{
    width:100%;
    padding:0 .5rem;
    font-size:12px;
    color:#5D5E5E;
    text-align: center;
  }
  .nav li p{
    margin-top:6px;
  }
  .nav_imaBox{
    padding: 0 .2rem;
  }
  /*门店展示*/
  .stores{
    padding: .25rem 0;
    margin: 0 .5rem 1rem;
    background-color:white;
    border-radius: .25rem;
    font-size: .7rem;
  }
  .store_name{
    text-align: center;
  }
  /* .store_img_box{
    height: 4.5rem;
  } */
  /* .store_img_box img{
    max-height: 3.5rem;
  } */
  .stores_head{
    padding:9px 12px;
    color:#E97A26;
    border-bottom:1px solid #eee;
  }
  .stores_head_icon{
    color:#E97620;
    font-size:18px;
  }
  .stores_content ul{
    margin:.4rem;
    display: flex;
    overflow-x: auto;
  }
  .stores_content li{
    width:25%;
    padding: .3rem;
    float:left;
    font-size: .5rem;
    color: #666;
    flex-shrink: 0;
  }
  .stores_content p{
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    padding-top: 10px;
  }
  /*技师列表*/
  .technician{
    text-align:center;
    margin: .75rem 0 .15rem;
    padding:0 .75rem;
  }
  .technician_label{
    font-size:18px;
    color:#45B9BC;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .technician_more{
    right: 0;
    position: absolute;
    font-size:12px;
    color:#8B8D8D;
    padding: .1rem;
  }
  .zfgf{
    top:11px;
    left:35%;
    width:3%;
    height:2px;
    background-color:#45B9BC;
    position: absolute;
  }
  .yfgf{
    top:11px;
    right:35%;
    width:3%;
    height:2px;
    background-color:#45B9BC;
    position: absolute;
  }

  .detail{
    background-color:#F4F5F6;
    text-align:center;
  }
  .detail_technician{
    padding: .75rem .4rem .5rem;
  }
  .detail_technician_list{
    background: #fff;
    box-shadow: 0 0 10px rgba(100, 100, 100, .15);
    text-align: center;
    padding: .5rem;
    width:100%;
  }
  .detail_avatar{
    border-radius:50%;
    width: 3.5rem;
    height: 3.5rem;
    margin: 0 auto .35rem;
    position: relative;
  }
  .detail_avatar_tech{
    border-radius:50%;
    height: 100%;
    border: 1px solid rgba(231,231,231,.7);
  }
  .seniorTech{
    border: 2px solid #F9CE06;
  }
  .seniorTech2{
    border-color: #329AF3;
  }
  .detail_avatar_crown{
    position: absolute;
    right: 0;
    top: 0;
    width: .75rem;
  }
  .detail_label{
    position: relative;
    line-height: 1rem;
  }
  .detail_name{
    font-size: .75rem;
    color:#606262;
  }
  .detail_position{
    font-size: .6rem;
    color:#909090;
    /* position: absolute; */
    bottom: 0;
    /* right: .5rem; */
    /* right: 0; */


  }
  .detail_skills{
    margin-bottom: .5rem;
  }
  .detail_skills span{
    background-color:#FBDEC9;
    color:#EC8B48;
    border-radius:5px;
    font-size: .6rem;
    margin:0 2px;
    padding:.1rem .25rem;
  }
  .detail_book{
    background-color:#45B9BC;
    color:white;
    border-radius:1.2rem;
    line-height: 1.2rem;
    font-size: .6rem;
    display:inline-block;
    padding: 0 .75rem;
  }
  /* .service_img{
        max-height: 5rem;
  } */

</style>



// WEBPACK FOOTER //
// src/views/index/index.vue